const SCOPE = 'app/wishList/';
export const ActionTypes = {
    ADD: `${SCOPE}ADD`,
    REMOVE: `${SCOPE}REMOVE`,
    CHANGE: `${SCOPE}CHANGE`,
};

export const add = (id) => ({
    type: ActionTypes.ADD,
    id: parseInt(id, 10),
});

export const remove = (id) => ({
    type: ActionTypes.REMOVE,
    id: parseInt(id, 10),
});

export const change = (list) => ({
    type: ActionTypes.CHANGE,
    list,
});
